import { Component, inject } from '@angular/core';
import { LogyardTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LogyardTypeCreateDto,
  LogyardTypeDto,
  LogyardTypeExcelDownloadDto,
  LogyardTypeUpdateDto,
} from '../proxy/planning/dtos/logyard-type';
import { LOGYARDTYPE_CONFIG, LOGYARDTYPE_FIELDS } from './logyard-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-logyard-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LogyardTypeService, ConfirmationService],
  templateUrl: './logyard-type.html',
  styleUrl: './logyard-type.scss',
})
export class LogyardType extends BaseCrudComponent<
  LogyardTypeDto,
  LogyardTypeCreateDto,
  LogyardTypeUpdateDto,
  LogyardTypeExcelDownloadDto
> {
  service = inject(LogyardTypeService);
  config = LOGYARDTYPE_CONFIG;
  fields = LOGYARDTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: LogyardTypeDto): LogyardTypeUpdateDto {
    return {
      name: data.name,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LogyardType';
  }
}
